import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "tabindex"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "modal-backdrop fade show" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      onMousedown: _cache[0] || (_cache[0] = (event) => _ctx.mouseDown(event)),
      onMouseup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.mouseUp && _ctx.mouseUp(...args))),
      class: "modal fade modal-open show display-block",
      id: _ctx.id,
      tabindex: _ctx.tabindex
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["modal-dialog modal-dialog-centered", _ctx.$attrs.class || 'modal-small']),
        role: "document"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ], 2 /* CLASS */)
    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1),
    _hoisted_3
  ]))
}